export const USER_LOADING = '@AUTH_USER_LOADING';
export const USER_LOADED = '@AUTH_USER_LOADED';
export const USER_LOGOUT = '@AUTH_USER_LOGOUT';
export const SET_ACTIVE_APP = '@AUTH_SET_ACTIVE_APP';
export const CLEAR_APP_DATA = '@AUTH_CLEAR_APP_DATA';

// login
export const LOGIN_SUCCEED = '@AUTH_LOGIN_SUCCEED';
export const AUTH_ERROR = '@AUTH_AUTH_ERROR';

